var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddButtonSymbol(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 19.5,
    fill: "#5AC69F",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 19.5,
    stroke: "#5AC69F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3555 21.2392C26.3555 22.5595 27.4258 23.6299 28.7462 23.6299H37C37.5523 23.6299 38 24.0776 38 24.6299C38 25.1822 37.5523 25.6299 37 25.6299H28.7462C27.4258 25.6299 26.3555 26.7002 26.3555 28.0206V37C26.3555 37.5523 25.9078 38 25.3555 38C24.8032 38 24.3555 37.5523 24.3555 37V28.0206C24.3555 26.7002 23.2851 25.6299 21.9648 25.6299H13C12.4477 25.6299 12 25.1822 12 24.6299C12 24.0776 12.4477 23.6299 13 23.6299H21.9648C23.2851 23.6299 24.3555 22.5595 24.3555 21.2392V13C24.3555 12.4477 24.8032 12 25.3555 12C25.9078 12 26.3555 12.4477 26.3555 13V21.2392Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButtonSymbol);
export default __webpack_public_path__ + "static/media/addButtonSymbol.24e4a1392a6c48dbf273754d7405f4a7.svg";
export { ForwardRef as ReactComponent };